"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _model = require("./model");

var _TicketMessage = require("./TicketMessage.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfoMessage = function InfoMessage(_ref) {
  var title = _ref.title,
      message = _ref.message;
  return /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicket, {
    id: "popup-ticket",
    style: {
      padding: 30
    }
  }, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketTitle, null, title), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketDesc, null, message));
};

var DialogPopup = function DialogPopup(_ref2) {
  var content = _ref2.content,
      status = _ref2.status;
  var message = (0, _model.getMessage)(content, status);
  var title = (0, _model.getTitle)(content);
  return /*#__PURE__*/_react.default.createElement(InfoMessage, {
    title: title,
    message: message
  });
};

var _default = DialogPopup;
exports.default = _default;